import React from 'react';
import { Heart } from 'lucide-react';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#8B1538] to-[#6B1028] text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Logo and Description */}
          <div className="md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_telfer-bridge/artifacts/8ou8i6z4_tgs-red.png"
              alt="TGS Logo"
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-white/80 leading-relaxed mb-4">
              Connecting Telfer students with industries beyond traditional business sectors. 
              Engineering. Science. Law. Your business degree opens more doors than you think.
            </p>
            <p className="text-sm text-white/60">
              University of Ottawa | Telfer School of Management
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('mission')}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Mission
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('industries')}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Industries
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('events')}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Events
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="font-bold text-lg mb-4">Connect</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="mailto:TGS.Executive@gmail.com"
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Email
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/tgsociety"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://linkedin.com/company/tgsociety"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 hover:text-white transition-colors"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-sm">
            © {new Date().getFullYear()} Telfer Gateway Society. All rights reserved.
          </p>
          <p className="text-white/60 text-sm flex items-center gap-2">
            Built with <Heart className="h-4 w-4 text-white fill-current" /> for Telfer students
          </p>
        </div>
      </div>
    </footer>
  );
};
